import {ServerIcon, TerminalIcon} from '@primer/octicons-react'

import {isRemoteTransport, type McpTransport} from '../types/mcp'
import styles from './ConnectorLogo.module.css'

export interface McpServerLogoProps {
  transport: McpTransport
  size?: number
}

/**
 * Stand-in tile for a personal MCP server.
 *
 * A user-authored server has no logo to show, so the icon carries the only
 * distinction worth drawing: whether Copilot reaches out to it or starts it.
 * Decorative, since the row already names the transport in text.
 */
export function McpServerLogo({transport, size = 32}: McpServerLogoProps) {
  const Icon = isRemoteTransport(transport) ? ServerIcon : TerminalIcon

  return (
    <span className={styles.logo} style={{width: size, height: size}} data-testid="mcp-server-logo">
      <Icon size={Math.round(size * 0.55)} />
    </span>
  )
}
